import dayjs from 'dayjs'
import { SERVER_DATE_TIME_FORMAT } from '@/components/desk/utils'

export const EventSaveTypes = {
  All: 0,
  Future: 1,
  CurrentOnly: -1
}

export function convertClientEventToServerEvent(clientEvent, infinityChecked = false) {
  const event = Object.assign({}, clientEvent)

  if (typeof event.remind === 'number' && event.start) {
    event.remind = event.start.add(clientEvent.remind, 'minute').format(SERVER_DATE_TIME_FORMAT)
  } else {
    event.remind = null
  }

  if (event.start) {
    event.start = infinityChecked ? dayjs().format(SERVER_DATE_TIME_FORMAT) : event.start.format(SERVER_DATE_TIME_FORMAT)
  }

  if (infinityChecked) {
    event.end = 'infinity'
  } else if (event.end) {
    event.end = event.end.format(SERVER_DATE_TIME_FORMAT)
  }

  return event
}

/**
 * @param serverEvent
 * @param buildingTimezone IANA timezone of the desk's building — booking times are always
 *   interpreted/edited in this zone, not the browser's, so the same booking reads the same
 *   regardless of where the viewer is.
 */
export function convertServerEventToClient(serverEvent, buildingTimezone) {
  const clientEvent = Object.assign({ key_: 1 }, serverEvent)
  if (clientEvent.start) {
    // the stored string already carries its own offset (ZZ) — parse it plainly first (which
    // resolves the correct absolute instant) and only then re-view it in the building's zone.
    // dayjs.tz(str, format, zone) must NOT be used here: it's only correct for offset-less
    // wall-clock strings and double-applies the offset when one is already present.
    clientEvent.start = dayjs(clientEvent.start, SERVER_DATE_TIME_FORMAT).tz(buildingTimezone)
  } else {
    clientEvent.start = dayjs().tz(buildingTimezone).hour(8).minute(0).second(0)
  }

  if (clientEvent.end === 'infinity') {
    clientEvent.end = clientEvent.start.hour(16).minute(0).second(0)
  }

  // note: when the infinity branch above ran, clientEvent.end is already a Dayjs instance here
  // (not a server string) — dayjs() ignores the format arg for non-string input and just clones it,
  // then .tz() re-applies the (already correct) building zone, so this stays correct either way
  clientEvent.end = clientEvent.end
    ? dayjs(clientEvent.end, SERVER_DATE_TIME_FORMAT).tz(buildingTimezone)
    : clientEvent.start.hour(16).minute(0).second(0)

  clientEvent.remind =
    clientEvent.start && clientEvent.remind ? dayjs(clientEvent.remind, SERVER_DATE_TIME_FORMAT).diff(clientEvent.start, 'minute') : null

  return clientEvent
}

export function getDeskHeader(desk) {
  return `Desk ${desk.number ?? ''}`
}
